import React, { Component } from "react";
import { useState, useEffect, useCallback } from "react";
import MaterialTable from "@material-table/core";
import Footer from "../../components/shared/Footer";
import Select, { ActionMeta } from "react-select";
import * as APIModels from "../../models";
import {
    ReportService,
    SubmissionService,
} from "../../services/SubmissionService";
import AttorneySelect from "../../components/shared/AttorneySelect";
import { ExportPdf, ExportCsv } from "@material-table/exporters";
import moment from "moment";
import { ClientService } from "../../services/ClientService";
import { FileService } from "../../services/SubmissionService";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

type NameValueOptionType = { label: string; value: string };

export default function Recent() {
    const [searching, setSearching] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const initialToDate = moment(Date.now()).toDate();
    const initialFromDate = moment(Date.now()).add(-1, "days").toDate();

    const [reportRequest, setReportRequest] =
        useState<APIModels.EFileReportRequest>({
            toDate: initialToDate.toISOString().substring(0, 10),
            fromDate: initialFromDate.toISOString().substring(0, 10),
        });

    const [firmId, setFirmId] = useState("");

    const [data, setData] = useState([] as APIModels.EFileReport[]);

    const onFirmSelected = (id: string, name: string) => {
        setFirmId(id);
    };

    const onSearchClick = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setSearching(true);
        setErrorMessage("");
        let attId = "";
        ClientService.firmAttorneys({ firmId }).then((resp) => {
            if (resp.successful && resp.data) {
                attId = resp.data![0].id!;
                ReportService.getRecentReporting({
                    attorneyId: attId,
                }).then(
                    (resp) => {
                        setSearching(false);
                        if (resp.successful === true) {
                            setData(resp.data as APIModels.EFileReport[]);
                            setErrorMessage(resp.errorMessage ?? "");
                        } else {
                            setErrorMessage(resp.errorMessage ?? "");
                        }
                    },
                    (error) => {
                        setSearching(false);
                        setErrorMessage("An error has occurred");
                    }
                );
            } else {
                setErrorMessage(resp.errorMessage ?? "");
            }
        });
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Reporting</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Reporting
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        e-Filing
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <form action="#" onSubmit={onSearchClick}>
                    <div className="row">
                        <div className="col-12 mb-3">
                            <AttorneySelect onFirmSelected={onFirmSelected} />
                        </div>
                        <div className="col-6 mb-3">
                            {searching ? (
                                <button
                                    className="btn btn-primary waves-effect waves-light mt-2"
                                    type="button"
                                    disabled={true}
                                >
                                    <span
                                        className="spinner-border spinner-border-sm me-1"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Searching...
                                </button>
                            ) : (
                                <button
                                    className="btn btn-primary waves-effect waves-light mt-2"
                                    type="submit"
                                    // onClick={onSearchClick}
                                >
                                    Search
                                </button>
                            )}
                            <span
                                style={{
                                    color: "red",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    marginLeft: "20px",
                                }}
                            >
                                Submissions may take up to 5 minutes to show in
                                this report
                            </span>
                            <div style={{ color: "red" }}>{errorMessage}</div>
                        </div>
                    </div>
                </form>

                <div className="row">
                    <div className="col-12">
                        <div style={{ maxWidth: "100%" }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <MaterialTable
                                    columns={[
                                        {
                                            title: "DATE",
                                            field: "DATE",
                                            type: "datetime",
                                            dateSetting: {
                                                format: "DD/MM/yyyy HH:MM:ss",
                                            },
                                            exportTransformer: (
                                                row: APIModels.EFileReport
                                            ) =>
                                                dayjs(row.DATE_FILED)
                                                    .tz("America/New_York") // Set the timezone to New York
                                                    .format(
                                                        "YYYY-MM-DD HH:mm:ss"
                                                    ), // Format the output to your desired format
                                        },
                                        {
                                            title: "PROCESS",
                                            field: "PROCESS",
                                        },
                                        {
                                            title: "ATTORNEY",
                                            field: "ATTORNEY",
                                        },
                                        {
                                            title: "FILENAME",
                                            field: "FILENAME",
                                        },
                                    ]}
                                    data={data}
                                    title="Recent Submissions"
                                    options={{
                                        exportAllData: true,
                                        pageSize: 50,
                                        pageSizeOptions: [5, 25, 50, 100, 200],
                                        exportMenu: [
                                            {
                                                label: "Export CSV with uppercase names",
                                                exportFunc: (cols, datas) =>
                                                    ExportCsv(
                                                        cols,
                                                        datas,
                                                        `RecentReport-${dayjs(
                                                            Date.now()
                                                        ).format("DD-MM-YY")}`
                                                    ),
                                            },
                                        ],
                                        tableLayout: "auto",
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
